import React from "react";
import { CircularProgress } from "@material-ui/core";

const Loader = ({ customLoader }) => {
  if (Boolean(customLoader))
    return <span className={"animate-spin"}>{customLoader}</span>;

  return <CircularProgress size={12} />;
};

const BaseButton = ({ children, disabled, loading, customLoader, ...rest }) => {
  const onDisabled = disabled || loading;

  return (
    <button
      {...rest}
      disabled={onDisabled}
      className={onDisabled ? "btn btn-disabled" : "btn btn-blue"}
      type="button"
      tabIndex="0"
    >
      {loading ? <Loader customLoader={customLoader} /> : children}
    </button>
  );
};

export default BaseButton;
